module.exports = __webpack_public_path__ + "assets/c6e8fc7679600c591c0fa6073a5a6f33.png";